import { useReducer } from "react";
import api from "../../Room/api/room.js";

const intialState = {
  specialities: [],
  worldSkills: []
};

function reducer(state, action) {
  switch (action.type) {
    case "SERVICES_FORM":
      return {
        ...state,
        specialities: action.specialities,
        worldSkills: action.worldSkills
      };
    default:
      return {
        ...state,
        ...action.payload
      };
  }
}

export default function useServices() {
  const [dataSources, dispatch] = useReducer(reducer, intialState);

  function getServicesForm() {
    Promise.all([
      api.getSpecialities(),
      api.getWorldSkills()
    ]).then(([specialities, worldSkills]) => {
      dispatch({
        type: "SERVICES_FORM",
        specialities: specialities.data,
        worldSkills: worldSkills.data
      });
    });
  }

  return {
    dataSources,
    getServicesForm
  };
}
